import { getI18n as e } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var t = {
	messages: {
		en: {
			redirectApi: {
				createAlreadyExists: "The redirect cannot be created because another redirect with this name already exists.",
				updateAlreadyExists: "The redirect cannot be updated because another redirect with this name already exists.",
				created: "Redirect created",
				updated: "Redirect updated",
				notFound: "Redirect not found",
				requiredFields: "The redirect cannot be saved because mandatory information is missing."
			},
			redirectList: {
				newButton: "New redirect",
				name: "Search for article (kicker, main headline, ID or URL)",
				deleteRedirect: "Delete",
				dpAny: "All",
				brand: "Brand",
				loading: "Loading redirect",
				headerLabel: "Label",
				headerCreatedAt: "Creation date",
				headerChangedAt: "Last modified date",
				counter: "Counter",
				dpEdit: "Edit",
				dpView: "View",
				messageDeleted: "Message deleted",
				errorOnDeleting: "Error deleting",
				createRedirect: "Create redirect"
			},
			redirect: {
				redirectLabel: "Redirect",
				kindArticle: "Article",
				kindCustom: "Custom",
				articleSelectionRequired: "Select an article",
				warnDifferentBrand: "The brand of the target article is different from the brand of the article to be redirected. Are you sure you want to set a redirect to this article?",
				warnUnpublishedTarget: "The selected target article is not published.",
				warnRedirectLoop: "The selected target article is itself being redirected. This could create a redirect loop.",
				newRedirect: "New redirect",
				messageDeleteRedirectBody: "Are you sure you want to remove this redirect? The initial article will be unpublished afterward.",
				messageDeleteRedirectTitle: "Remove redirect",
				removeRedirect: "Remove redirect",
				messageSaveRedirectTitle: "Create redirect",
				messageSaveRedirectConfirm: "Are you sure you want to create a permanent 301 redirect for the article \"{title}\"?",
				createRedirectConfirm: "Create redirect",
				messageUpdateRedirectTitle: "Update redirect",
				messageUpdateRedirectConfirm: "Are you sure you want to update this permanent 301 redirect for the article \"{title}\"?",
				updateRedirectConfirm: "Update redirect",
				deleteRedirect: "Remove redirect",
				messageDeleted: "Redirect deleted",
				errorOnDeleting: "Error deleting the redirect",
				errorFailedLoadedRedirectWithId: "Error getting the redirect",
				to: "To",
				from: "From",
				comment: "Comment",
				invalidPathOrUrl: "Invalid path or URL"
			},
			redirectEdit: {
				label: "Label",
				counter: "Counter",
				goToPage: "To page",
				editRedirect: "Edit redirect",
				messageSaved: "New redirect saved",
				deleteRedirect: "Remove redirect"
			}
		},
		de: {
			redirectApi: {
				createAlreadyExists: "Der Redirect kann nicht erstellt werden, weil bereits ein Redirect mit diesem Namen existiert.",
				updateAlreadyExists: "Der Redirect kann nicht aktualisiert werden, weil bereits ein Redirect mit diesem Namen existiert.",
				created: "Redirect erstellt",
				updated: "Redirect aktualisiert",
				notFound: "Redirect nicht gefunden",
				requiredFields: "Der Redirect kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
			},
			redirectList: {
				newButton: "Neuer Redirect",
				name: "Suchen nach Artikel (Vorspann, Hauptzeile, ID oder URL)",
				deleteRedirect: "Löschen",
				dpAny: "Alle",
				brand: "Marke",
				loading: "Lade Redirect",
				headerLabel: "Bezeichnung",
				headerCreatedAt: "Erstellungsdatum (creation date)",
				headerChangedAt: "Änderungsdatum (last modified)",
				counter: "Zähler",
				dpEdit: "Bearbeiten",
				dpView: "Anzeigen",
				messageDeleted: "Nachricht gelöscht",
				errorOnDeleting: "Fehler beim Löschen",
				createRedirect: "Redirect erstellen"
			},
			redirect: {
				redirectLabel: "Redirect",
				kindArticle: "Artikel",
				kindCustom: "Benutzerdefiniert",
				articleSelectionRequired: "Bitte einen Artikel auswählen.",
				warnDifferentBrand: "Die Marke des Zielartikels weicht von der Marke des umzuleitenden Artikels ab. Willst du diesen Redirect wirklich setzen?",
				warnUnpublishedTarget: "Der ausgewählte Zielartikel ist nicht veröffentlicht.",
				warnRedirectLoop: "Der ausgewählte Zielartikel wird selbst weitergeleitet. Es könnte eine Redirect-Schleife entstehen.",
				newRedirect: "Neuer Redirect",
				messageDeleteRedirectBody: "Willst du diesen Redirect wirklich entfernen? Der Ausgangsartikel wird anschließend depubliziert.",
				messageDeleteRedirectTitle: "Redirect entfernen",
				removeRedirect: "Redirect entfernen",
				messageSaveRedirectTitle: "Redirect erstellen",
				messageSaveRedirectConfirm: "Willst du wirklich einen permanenten 301-Redirect für den Artikel „{title}“ erstellen?",
				createRedirectConfirm: "Redirect erstellen",
				messageUpdateRedirectTitle: "Redirect aktualisieren",
				messageUpdateRedirectConfirm: "Willst du diesen permanenten 301-Redirect für den Artikel „{title}“ wirklich aktualisieren?",
				updateRedirectConfirm: "Redirect aktualisieren",
				deleteRedirect: "Redirect entfernen",
				messageDeleted: "Redirect gelöscht",
				errorOnDeleting: "Fehler beim Löschen des Redirects",
				errorFailedLoadedRedirectWithId: "Fehler beim Abrufen des Redirects",
				to: "Nach",
				from: "Von",
				comment: "Kommentar",
				invalidPathOrUrl: "Pfad oder URL ungültig"
			},
			redirectEdit: {
				label: "Bezeichnung",
				counter: "Zähler",
				goToPage: "Zur Seite",
				editRedirect: "Redirect bearbeiten",
				messageSaved: "Neuer Redirect gespeichert",
				deleteRedirect: "Redirect entfernen"
			}
		}
	},
	routes: [{
		path: "/redirect",
		children: [
			{
				path: "",
				name: "redirect_list",
				component: () => import("./redirect-list.view-9Cfm2VtJ.js"),
				meta: { requiredRight: "redirect-management:navigate" }
			},
			{
				path: "new",
				name: "redirect_new",
				component: () => import("./redirect-edit.view-Bx-7hRlM.js"),
				props: () => ({
					title: e().t("redirect.newRedirect"),
					backRoute: "/redirect"
				}),
				meta: { requiredRight: ["redirect-management:navigate"] }
			},
			{
				path: ":id",
				name: "redirect_detail",
				component: () => import("./redirect-edit.view-Bx-7hRlM.js"),
				props: (t) => ({
					title: e().t("redirectEdit.editRedirect"),
					id: t.params.id,
					backRoute: "/redirect"
				}),
				meta: { requiredRight: ["redirect-management:navigate"] }
			}
		]
	}],
	contentBlocks: []
};
//#endregion
export { t as redirectModule };

//# sourceMappingURL=index.es.js.map